module.exports = __webpack_public_path__ + "static/media/shivashankar.6e16f0d6.png";